<div class="grid grid-cols-[3rem_5rem_1fr]">
    <div></div>

    <div
        class="h-full justify-self-center border border-dashed border-[#838383] dark:border-contrast-yellow dark:text-contrast-yellow"></div>

    <div class="mb-2 mt-2 flex">
        <ion-icon name="walk"></ion-icon>
        <p class="ml-1 text-xs text-[#838383] dark:text-contrast-yellow">
            {{ 'ITINERARY_INSTRUCTIONS_WALK' | translate }} {{ leg.duration | duration }}
            <ng-container *ngIf="leg.distance">
                ({{ leg.distance | distance }}) {{ destinationText | translate | lowercase }}
            </ng-container>
        </p>
    </div>
</div>
